import React from "react";
import "../styles/Navigation.scss";
import PDF from "../assets/data/Resume.pdf";

export function Navigation() {
  return (
    <header className="header">
      <div>
        <span>C</span>. Adams
      </div>
      <nav>
        <a href="#about">About</a>
        <a href="#skills">Skills</a>
        <a href="#work">Work</a>
        <a href="mailto:cladams0203@gmail.com">Contact</a>
        <a
          className="resume"
          href={PDF}
          target="_blank"
          rel="noopener noreferrer"
        >
          Resume
        </a>
      </nav>
    </header>
  );
}
